<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="2">
                <v-btn-primary
                    block
                    style="white-space: nowrap; text-overflow: ellipsis"
                    @click="openDialogEbic()"
                    >Ajouter</v-btn-primary
                >
            </v-col>
            <v-col cols="10" class="d-flex align-center justify-end px-4">
                <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn-icon
                            icon="$fa-sync-alt"
                            elevation="0"
                            @click="openDialogBankTransactionAPIs()"
                            :loading="loadingUpdateAPI"
                            v-bind="props"
                        >
                        </v-btn-icon>
                    </template>
                    <span>Actualiser les connexions</span>
                </v-tooltip>
                <oss-dialog
                    v-model="dialogBankTransactionAPIs"
                    title="Définir la date de début d'import"
                    :previous-disabled="refreshEbicStep === 'main'"
                    :hideValid="!(refreshEbicStep !== 'main')"
                    @close="
                        dialogBankTransactionAPIs = false;
                        resetRefreshEbicDialog();
                    "
                    @previous="resetRefreshEbicDialog()"
                    @valid="validRefreshEbics()"
                    width="50vw"
                >
                    <v-window v-model="refreshEbicStep">
                        <v-window-item :key="0" :value="'main'">
                            <v-list subheader lines="two">
                                <v-list-item
                                    :class="
                                        !$vuetify.display.mobile
                                            ? 'mb-2 oss-list-item'
                                            : 'mb-2 px-2 oss-list-item'
                                    "
                                    @click="refreshEbicStep = 'updateJDC'"
                                >
                                    <v-list-item-title>JeDéclare.com</v-list-item-title>
                                    <v-list-item-subtitle
                                        >Forcer la mise a jour de
                                        JeDéclare.com</v-list-item-subtitle
                                    >
                                    <template #append>
                                        <v-btn-icon icon="$chevron_right" />
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    :class="
                                        !$vuetify.display.mobile
                                            ? 'mb-2 oss-list-item'
                                            : 'mb-2 px-2 oss-list-item'
                                    "
                                    @click="refreshEbicStep = 'updateSoBank'"
                                >
                                    <v-list-item-title>SoBank</v-list-item-title>
                                    <v-list-item-subtitle
                                        >Forcer la mise a jour de Sobank</v-list-item-subtitle
                                    >
                                    <template #append>
                                        <v-btn-icon icon="$chevron_right" />
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    :class="
                                        !$vuetify.display.mobile
                                            ? 'mb-2 oss-list-item'
                                            : 'mb-2 px-2 oss-list-item'
                                    "
                                    @click="refreshEbicStep = 'refreshImports'"
                                >
                                    <v-list-item-title>Actualiser les imports</v-list-item-title>
                                    <v-list-item-subtitle
                                        >Actualiser les imports EBICs
                                        existants</v-list-item-subtitle
                                    >
                                    <template #append>
                                        <v-btn-icon icon="$chevron_right" />
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-window-item>
                        <v-window-item :key="1" :value="'refreshImports'">
                            <v-row no-gutters>
                                <v-col cols="12" class="py-2">
                                    <oss-date-picker-filled
                                        v-model="dateStart"
                                        label="Date de début"
                                        :min-date="minDateRefreshEbics"
                                        :max-date="maxDateRefreshEbics"
                                    />
                                </v-col>
                            </v-row>
                        </v-window-item>
                        <v-window-item :key="2" :value="'updateJDC'">
                            <v-row no-gutters>
                                <v-col cols="12" class="py-2">
                                    <oss-date-picker-filled
                                        v-model="dateStart"
                                        label="Date de début"
                                        :min-date="minDateRefreshEbics"
                                        :max-date="maxDateRefreshEbics"
                                    />
                                </v-col>
                            </v-row>
                        </v-window-item>
                        <v-window-item :key="3" :value="'updateSoBank'">
                            <v-row no-gutters>
                                <v-col cols="12" class="py-2">
                                    <oss-date-picker-filled
                                        v-model="dateStart"
                                        label="Date de début"
                                        :min-date="minDateRefreshEbics"
                                        :max-date="maxDateRefreshEbics"
                                    />
                                </v-col>
                            </v-row>
                        </v-window-item>
                    </v-window>
                </oss-dialog>
            </v-col>
        </v-row>
        <v-row
            no-gutters
            class="d-flex justify-center pt-3"
            :style="'max-height:' + maxHeight + ';' + 'overflow:auto'"
        >
            <v-col cols="12" class="d-flex justify-center">
                <v-card class="default_card_wm" elevation="0" style="width: inherit">
                    <v-list flat>
                        <template v-if="accountingItemImports && accountingItemImports.length">
                            <v-list-item class="pb-3">
                                <v-row no-gutters>
                                    <v-col cols="3" class="d-flex align-center font-weight-bold">
                                        Nom
                                    </v-col>
                                    <v-col
                                        cols="2"
                                        class="d-flex align-center justify-center font-weight-bold"
                                    >
                                        Date d'importation du fichier
                                    </v-col>
                                    <v-col
                                        cols="2"
                                        class="d-flex align-center justify-center font-weight-bold"
                                    >
                                        Dernière mise à jour dans bobbee
                                    </v-col>
                                    <v-col
                                        cols="2"
                                        class="d-flex align-center justify-center font-weight-bold"
                                    >
                                        Statut
                                    </v-col>
                                    <v-col cols="2" class="d-flex align-center font-weight-bold">
                                        Origine
                                    </v-col>
                                    <v-col
                                        cols="1"
                                        class="d-flex align-center justify-center font-weight-bold"
                                    >
                                        Action
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-virtual-scroll
                                bench="5"
                                :items="accountingItemImports"
                                class="striped"
                            >
                                <template v-slot:default="{ item, index }">
                                    <v-list-item :key="index" class="pb-3">
                                        <v-row no-gutters>
                                            <v-col cols="3" class="d-flex align-center">
                                                {{ getTitle(item) }}
                                            </v-col>
                                            <v-col
                                                cols="2"
                                                class="d-flex align-center justify-center"
                                            >
                                                {{ formatDate(item.createdAt) }}
                                            </v-col>
                                            <v-col
                                                cols="2"
                                                class="d-flex align-center justify-center"
                                            >
                                                {{ formatDate(item.updatedAt) }}
                                            </v-col>
                                            <v-col cols="2" class="d-flex align-center px-5">
                                                <v-row no-gutters>
                                                    <v-col
                                                        cols="12"
                                                        class="d-flex align-center justify-center"
                                                    >
                                                        <v-chip
                                                            label
                                                            :color="statusColor(item.status)"
                                                            size="x-small"
                                                            >{{
                                                                $t(
                                                                    `accountingItemImport.status.${item.status}`,
                                                                )
                                                            }}</v-chip
                                                        >
                                                    </v-col>
                                                    <v-col cols="12"> </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col cols="2" class="d-flex align-center">
                                                {{ getImportType(item) }}
                                            </v-col>
                                            <v-col cols="1" class="d-flex justify-space-around">
                                                <!-- <v-btn
                                                icon
                                                color="primary"
                                                @click="reloadImport(item)"
                                            >
                                                <v-icon  size="small">$fa-redo-alt</v-icon>
                                            </v-btn> -->
                                                <v-btn-icon
                                                    icon="$fa-redo-alt"
                                                    size="small"
                                                    :disabled="
                                                        !item.status.startsWith('IMPORTED') &&
                                                        !item.status.startsWith('REJECTED')
                                                    "
                                                    @click="displayBankTransactions(item)"
                                                >
                                                </v-btn-icon>
                                                <v-btn-icon
                                                    v-if="item.file && item.file.id"
                                                    icon="$oss-download"
                                                    size="small"
                                                    @click="downloadFile(item)"
                                                >
                                                </v-btn-icon>
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ props }">
                                                        <v-btn-icon
                                                            icon="$dots_vertical"
                                                            size="small"
                                                            v-bind="props"
                                                        />
                                                    </template>
                                                    <v-list>
                                                        <v-list-item
                                                            :title="'Rejeter'"
                                                            @click="
                                                                toDeleteAccountingItemImportId =
                                                                    item.id;
                                                                rejectAccountingItemImportDialog = true;
                                                            "
                                                        >
                                                            <template v-slot:append>
                                                                <v-btn
                                                                    icon="$warning"
                                                                    size="x-small"
                                                                    class="ml-1"
                                                                >
                                                                </v-btn>
                                                            </template>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-progress-linear
                                                    v-if="getAdvance(item) !== 100"
                                                    :indeterminate="!getAdvance(item)"
                                                    rounded
                                                    :model-value="getAdvance(item)"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </template>
                            </v-virtual-scroll>
                        </template>
                        <template v-else>
                            <v-list-item class="oss-list-item py-3">
                                <v-row no-gutters>
                                    <v-col
                                        cols="12"
                                        class="d-flex align-center justify-center pb-4"
                                    >
                                        Aucun import n'a été trouvés
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center justify-center">
                                        <v-btn
                                            rounded
                                            elevation="0"
                                            @click="openDialogEbic()"
                                            size="small"
                                        >
                                            Créer un import EBICS
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>
        <oss-dialog
            v-model="ebicsDialog"
            title="Import EBICS"
            :hideValid="windowStep !== 1"
            :loading="loading"
            @valid="valid()"
            @close="closeEbicsDialog()"
            v-if="ebicsDialog"
            width="60vw"
        >
            <v-row no-gutters>
                <v-col cols="12">
                    <v-window v-model="windowStep" touchless>
                        <v-window-item :value="0">
                            <v-card-text>
                                {{ error }}
                                <UploadDocuments
                                    :showFirstPrevious="true"
                                    :companyId="company.id"
                                    :documentType="'BANK_STATEMENT'"
                                    :inExtensions="['dat']"
                                    :multiple="false"
                                    :freeTag="false"
                                    :gDrive="false"
                                    :maxSize="0"
                                    @fileInput="readFile($event)"
                                />
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="1">
                            <template v-if="!bankAccounts || !bankAccounts.length">
                                <v-card-title
                                    class="title font-weight-regular justify-space-between"
                                >
                                    <span>Chargement en cours...</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="d-flex align-center justify-center">
                                            <v-progress-linear indeterminate rounded />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </template>
                            <template v-else>
                                <v-card-title
                                    class="title font-weight-regular justify-space-between pt-0 mt-0"
                                >
                                    <span
                                        >Comptes bancaires :
                                        {{
                                            bankAccounts
                                                ? foundBankAccounts + "/" + bankAccounts.length
                                                : foundBankAccounts
                                        }}</span
                                    >
                                </v-card-title>
                                <v-card-text>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <div>
                                                <v-icon color="secondary" size="x-small"
                                                    >$fa-check</v-icon
                                                >
                                                Mouvements bancaires importés:
                                                {{ totalBankTransactionImported }}/{{
                                                    totalBankTransactionCount
                                                }}
                                            </div>
                                            <div v-if="totalErrors" class="text-red">
                                                <v-icon color="error" size="x-small"
                                                    >$fa-exclamation-triangle</v-icon
                                                >
                                                Mouvements bancaires en erreur:
                                                {{ totalErrors }}/{{ totalBankTransactionCount }}
                                            </div>
                                            <div v-if="totalWarnings" class="warning--text">
                                                <v-icon color="warning" size="x-small"
                                                    >$fa-exclamation-triangle</v-icon
                                                >
                                                Mouvements bancaires non importés:
                                                {{ totalWarnings }}/{{ totalBankTransactionCount }}
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <!-- <v-switch
                                                v-model="onlyFound"
                                                color="primary"
                                                label="Seulement les comptes bancaires associés à un dossier"
                                                inset
                                            ></v-switch> -->
                                            <v-select-filled
                                                v-model="filterBankAccount"
                                                :items="filteredBankAccountsList"
                                                item-value="value"
                                                label="Filtrer"
                                                class="mt-3"
                                                outlined
                                                hide-details
                                                density="compact"
                                                :item-title="(item) => item.text"
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-list
                                                style="background-color: transparent"
                                                lines="two"
                                            >
                                                <v-virtual-scroll
                                                    :item-height="100"
                                                    :items="filteredBankAccounts"
                                                    height="450"
                                                    class="py-3"
                                                    bench="2"
                                                >
                                                    <template v-slot="{ item }">
                                                        <v-list-item
                                                            :key="item.key"
                                                            :class="getItemClass(item)"
                                                            height="100px"
                                                            :active="false"
                                                            :link="false"
                                                        >
                                                            <v-list-item-title class="pb-1">
                                                                {{ item.partialIban }} - Solde =
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        item.balance.balance,
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </v-list-item-title>
                                                            <v-list-item-subtitle>
                                                                <v-icon size="x-small" class="mr-2"
                                                                    >$fa-university</v-icon
                                                                >
                                                                {{ getDBBAText(item) }}
                                                            </v-list-item-subtitle>
                                                            <div
                                                                v-if="
                                                                    item &&
                                                                    item.errors &&
                                                                    item.errors.length
                                                                "
                                                            >
                                                                <v-icon
                                                                    class="mr-2"
                                                                    color="red"
                                                                    size="x-small"
                                                                    >$report_problem</v-icon
                                                                >
                                                                {{ getErrors(item) }}
                                                            </div>
                                                            <div
                                                                v-if="
                                                                    item &&
                                                                    item.warnings &&
                                                                    item.warnings.length
                                                                "
                                                            >
                                                                <v-icon
                                                                    class="mr-2"
                                                                    color="orange"
                                                                    size="x-small"
                                                                    >$report_problem</v-icon
                                                                >
                                                                {{ getWarnings(item) }}
                                                            </div>
                                                            <template
                                                                v-if="
                                                                    getItemClass(item) ===
                                                                        'oss-list-item-selected-inactive' ||
                                                                    getItemClass(item) ===
                                                                        'oss-list-item-selected'
                                                                "
                                                            >
                                                                <div>
                                                                    <template
                                                                        v-if="
                                                                            (item.btCount || 0) !==
                                                                            item.bankTransactionCount
                                                                        "
                                                                    >
                                                                        <span class="text-red">
                                                                            <v-icon
                                                                                color="error"
                                                                                size="x-small"
                                                                                >$fa-exclamation-triangle</v-icon
                                                                            >
                                                                            {{ item.btCount || 0 }}
                                                                            /
                                                                            {{
                                                                                item.bankTransactionCount ||
                                                                                0
                                                                            }}
                                                                            mouvements bancaires
                                                                            importés
                                                                        </span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <v-icon
                                                                            color="secondary"
                                                                            size="x-small"
                                                                            >$fa-check</v-icon
                                                                        >
                                                                        {{ item.btCount || 0 }}
                                                                        /
                                                                        {{
                                                                            item.bankTransactionCount ||
                                                                            0
                                                                        }}
                                                                        mouvements bancaires
                                                                        importés
                                                                    </template>
                                                                </div>
                                                            </template>
                                                        </v-list-item>
                                                    </template>
                                                </v-virtual-scroll>
                                            </v-list>
                                        </v-col>
                                        <!-- <v-col cols="12" class="d-flex justify-end">
                                            <v-btn
                                                rounded
                                                color="secondary"
                                                 size="small"
                                                elevation-0
                                                @click="valid"
                                                :disabled="!isImportable"
                                                :loading="loading"
                                            >Valider</v-btn>
                                        </v-col> -->
                                    </v-row>
                                </v-card-text>
                            </template>
                        </v-window-item>
                        <v-window-item :value="2">
                            <v-card-title class="title font-weight-regular justify-space-between">
                                Importé
                            </v-card-title>
                        </v-window-item>
                    </v-window>
                </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="rejectAccountingItemImportDialog"
            title="Rejeter l'import EBICS"
            @valid="rejectAccountingItemImport()"
            :validLoading="deleteAccountingItemImportLoading"
            width="850px"
        >
            <div class="text-center">
                <h4>&#xca;tes-vous sûr(e) de vouloir rejeter cet import EBIC ?</h4>
                <div>
                    Il ne sera pas supprimé, et vous pourrez toujours récupérer plus tard les
                    mouvements bancaires depuis cette page
                </div>
                <div>
                    Attention : Par contre toutes les manipulations effectuées sur les mouvements
                    bancaires (Lettrages...) depuis leur création seront définitivement perdues
                </div>
            </div>
        </oss-dialog>
        <v-snackbar v-model="snackbar">
            Mise a jour des comptes bancaires en cours. L'opération peut prendre du temps. Merci de
            patienter
            <template v-slot:actions>
                <v-btn @click="snackbar = false" variant="text"> Close </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import gql from "graphql-tag";
import moment from "moment-timezone";

import getEnv from "../../env";
import ACCOUNTING_ITEMS_IMPORT from "../../graphql/accountingItem/AccountingItemImports.gql";
import DELETE_EDIT_ACCOUNTING_ITEM_IMPORT from "../../graphql/accountingItem/DeleteEditAccountingItemImport.gql";
import UPDATE_EBICS from "../../graphql/accountingItem/UpdateEbics.gql";
import UPDATE_BANK_TRANSACTIONS_APIS from "../../graphql/bankTransaction/UpdateBankTransactionsAPIs.gql";
import UPDATE_SOBANK_APIS from "../../graphql/bankTransaction/UpdateSobankAPIs.gql";

import UploadDocuments from "../document/UploadDocuments.vue";
import { NotificationBase } from "../NotificationBase";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";

const env = getEnv();

@Component({
    components: {
        UploadDocuments,
    },
})
export class ImportEBICS extends NotificationBase {
    windowStep = 0;

    stream = null;

    bankAccounts = [];

    fileName = "";

    onlyFound = true;

    loading = false;

    ebicsDialog = false;

    ebicsStep = 0;

    error = "";

    selectedAccountingItemImport = "";

    loadingUpdateAPI = false;

    snackbar = false;

    totalBankTransactionImported = 0;

    filterBankAccount = "ONLY_WITH_COMPANY";

    rejectAccountingItemImportDialog = false;

    toDeleteAccountingItemImportId = "";

    get company() {
        return this.$store.state.user.company;
    }

    get ibans() {
        const result = this.bankAccounts.flatMap((x) => x.dbBankAccounts);
        return result;
    }

    get isImportable() {
        let bankAccount = this.bankAccounts.find(
            (x) => x.dbBankAccounts && x.dbBankAccounts.length > 1,
        );
        if (bankAccount) {
            return false;
        }
        bankAccount = this.bankAccounts.find(
            (x) =>
                x.dbBankAccounts &&
                x.dbBankAccounts.length === 1 &&
                (!x || !x.errors || x.errors.length === 0) &&
                (!x.warnings || x.warnings.length === 0),
        );
        if (bankAccount) {
            return true;
        }
        return false;
    }

    get foundBankAccounts() {
        let count = 0;
        for (const ba of this.bankAccounts) {
            if (!ba.dbBankAccounts || !ba.dbBankAccounts.length) {
                continue;
            }
            count++;
        }
        return count;
    }

    get minDateRefreshEbics() {
        switch (this.refreshEbicStep) {
            case "refreshImports": {
                return moment().subtract(1, "year").format("YYYY-MM-DD");
            }
            case "updateJDC": {
                return moment().subtract(3, "weeks").format("YYYY-MM-DD");
            }
        }
        return null;
    }

    maxDateRefreshEbics = moment().format("YYYY-MM-DD");

    get filteredBankAccounts() {
        switch (this.filterBankAccount) {
            case "ONLY_WITH_COMPANY": {
                const bankAccounts = [];
                for (const ba of this.bankAccounts) {
                    if (!ba.dbBankAccounts || !ba.dbBankAccounts.length) {
                        continue;
                    }
                    bankAccounts.push(ba);
                }
                return bankAccounts;
            }
            case "DIFF_BTW_IN_FILE_AND_IN_DB": {
                const bankAccounts = [];
                debugger;
                for (const ba of this.bankAccounts) {
                    if (ba.btCount && ba.btCount !== ba.bankTransactionCount) {
                        bankAccounts.push(ba);
                    }
                }
                return bankAccounts;
            }
            case "NEW_BANKACCOUNT": {
                const bankAccounts = [];
                for (const ba of this.bankAccounts) {
                    if (
                        !ba.dbBankAccounts ||
                        !ba.dbBankAccounts.length ||
                        ba.btCount ||
                        !ba.bankTransactionCount
                    ) {
                        continue;
                    }
                    bankAccounts.push(ba);
                }
                return bankAccounts;
            }
            default: {
                return this.bankAccounts;
            }
        }
    }

    get totalBankTransactionCount() {
        const bankAccounts = [];
        for (const ba of this.bankAccounts) {
            if (!ba.dbBankAccounts || !ba.dbBankAccounts.length) {
                continue;
            }
            bankAccounts.push(ba.bankTransactionCount);
        }
        return bankAccounts.reduce((partialSum, a) => partialSum + a, 0);
    }

    get accountingItemImportId() {
        if (this.accountingItemImports?.length) {
            return this.accountingItemImports.map((x) => x.id);
        }
        return [];
    }

    get skipSmartQuery() {
        if (this.accountingItemImports) {
            if (this.accountingItemImports.length) {
                return false;
            }
            return true;
        }
        return false;
    }

    get filteredBankAccountsList() {
        return [
            { text: "Tous les comptes bancaires", value: "ALL" },
            { text: "Seulement les comptes rattachés à un dossier", value: "ONLY_WITH_COMPANY" },
            {
                text: "Seulement les comptes avec une différence entre les mouvements dans le fichier et dans bobbee",
                value: "DIFF_BTW_IN_FILE_AND_IN_DB",
            },
            { text: "Seulement les nouveaux comptes bancaires", value: "NEW_BANKACCOUNT" },
        ];
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (160 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    dialogBankTransactionAPIs = false;

    dateStart = null;

    refreshEbicStep = "main";

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    openDialogBankTransactionAPIs() {
        this.dialogBankTransactionAPIs = true;
    }

    resetRefreshEbicDialog() {
        this.dateStart = moment().subtract(3, "days").format("YYYY-MM-DD");
        this.refreshEbicStep = "main";
    }

    validRefreshEbics() {
        switch (this.refreshEbicStep) {
            case "refreshImports": {
                const ebicsIdsList = this.accountingItemImports
                    .filter((aii) => moment(aii.createdAt).isSameOrAfter(moment(this.dateStart)))
                    .map((aii) => aii.id);
                console.log(ebicsIdsList);
                this.$apollo.mutate({
                    mutation: UPDATE_EBICS,
                    variables: {
                        accountingItemImportIds: ebicsIdsList,
                    },
                });
                break;
            }
            case "updateJDC": {
                this.updateBankTransactionAPIs();
                break;
            }
            case "updateSoBank": {
                // debugger // NOT FINISHED
                this.updateSobankAPIs();
                break;
            }
        }
        this.dialogBankTransactionAPIs = false;
        this.resetRefreshEbicDialog();
    }

    beforeMount() {
        this.dateStart = moment().subtract(3, "days").format("YYYY-MM-DD");
        this.addListener("accountingItemImport");
    }

    beforeDestroy() {
        this.removeListener();
    }

    onMessage(data) {
        if (data) {
            if (data.action === "create" || data.action === "update") {
                const accountingItemImport = this.accountingItemImports.find(
                    (aie) => aie.id === data.id,
                );
                if (accountingItemImport) {
                    accountingItemImport.status = data.payload.status;
                    accountingItemImport.step = data.payload.step;
                    accountingItemImport.stepCount = data.payload.stepCount;
                    accountingItemImport.createdAt = data.payload.createdAt;
                    accountingItemImport.updatedAt = data.payload.updatedAt;
                }
            } else if (data.action === "delete") {
                const index = this.accountingItemImports.findIndex((aie) => aie.id === data.id);
                if (index !== -1) {
                    this.accountingItemImports.splice(index, 1);
                }
            }
        }
    }

    getTitle(item) {
        let title = item.name || "";
        if (item.importId) {
            if (title) title += " ";
            title += "(";
            title += item.importId;
            title += ")";
        }
        return title;
    }

    getItemClass(item) {
        if (item && item.errors && item.errors.length) {
            return "oss-list-item-ko";
        }
        if (item && item.warnings && item.warnings.length) {
            return "oss-list-item-selected-inactive";
        }
        if (item && item.dbBankAccounts && item.dbBankAccounts.length === 1) {
            return "oss-list-item-selected";
        }
        return "oss-list-item-inactive";
    }

    openDialogEbic() {
        this.fileName = "";
        this.ebicsStep = 0;
        this.ebicsDialog = true;
    }

    getDBBAText(item) {
        if (item.dbBankAccounts && item.dbBankAccounts.length) {
            let text = "";
            for (const ba of item.dbBankAccounts) {
                if (text) text += " - ";
                text +=
                    item.dbBankAccounts[0].company.name + " (" + item.dbBankAccounts[0].name + ")";
            }
            return text;
        }
        return "Aucun compte bancaire trouvé";
    }

    getErrors(item) {
        let errors = "";
        if (item && item.errors) {
            for (const e of item.errors) {
                if (errors) errors += " - ";
                errors += this.$t("importEBICS." + e);
            }
        }
        return errors;
    }

    getWarnings(item) {
        let warnings = "";
        if (item.warnings) {
            for (const w of item.warnings) {
                if (warnings) warnings += " - ";
                if (w === "alreadyImported")
                    warnings += `${item.btCount}/${item.bankTransactionCount} `;
                warnings += this.$t("importEBICS." + w);
            }
        }
        return warnings;
    }

    get totalWarnings() {
        let total = 0;
        for (const ba of this.bankAccounts) {
            if (ba.warnings?.length) {
                total += ba.bankTransactionCount;
            }
        }
        return total;
    }

    get totalErrors() {
        let total = 0;
        for (const ba of this.bankAccounts) {
            if (ba.errors?.length) {
                total += ba.bankTransactionCount;
            }
        }
        return total;
    }

    get totalWithoutWarnings() {
        return this.totalBankTransactionCount - this.totalWarnings;
    }

    getAdvance(item) {
        if (item.stepCount) {
            return Math.round((item.step / item.stepCount) * 100);
        }
        return 0;
    }

    getImportType(item) {
        switch (item.type) {
            case "EBICS_JE_DECLARE":
                return "JeDeclare.com";
            case "EBICS_SO_BANK":
                return "SoBank";
            case "EBICS_MANUAL":
                return "Manuelle";
            default:
                return "";
        }
    }

    // setUpSmartQuery() {
    // this.$apollo.addSmartQuery("accountingItemImports", {
    @Apollo({
        query: ACCOUNTING_ITEMS_IMPORT,
        variables() {
            return {
                companyId: this.company.id,
                types: ["EBICS_JE_DECLARE", "EBICS_SO_BANK", "EBICS_MANUAL"],
                orderBy: "createdAt_DESC",
            };
        },
        skip() {
            return this.skipSmartQuery;
        },
        fetchPolicy: "network-only",
        specificResult({ data, loading, networkStatus }) {
            if (!loading) {
                if (data) {
                    this.accountingItemImports = data.accountingItemImports;
                    // console.log('accountingItemImports', this.accountingItemImports)
                } else {
                    this.accountingItemImports = [];
                }
            }
        },
    })
    accountingItemImports = null;

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.accountingItemImports) {
            this.$apollo.queries.accountingItemImports.refetch();
        } else {
            debugger;
        }
    }

    closeEbicsDialog() {
        this.ebicsDialog = false;
        this.windowStep = 0;
        this.selectedAccountingItemImport = "";
    }

    downloadFile(item) {
        window.open(`${env.VUE_APP_BACKEND}/accountingItemImport/download/${item.id}`, "_blank");
    }

    async readFile(e) {
        if (e && e.file) {
            this.fileName = e.displayName;
            const reader = new FileReader();
            const self = this;
            reader.onload = async function () {
                const { result } = reader;
                self.stream = result;

                const mutationResult = await self.$apollo.mutate({
                    mutation: gql`
                        mutation AnalyseEBICS(
                            $accountingCompanyId: ID!
                            $fileName: String!
                            $stream: String!
                        ) {
                            analyseEBICS(
                                data: {
                                    fileName: $fileName
                                    stream: $stream
                                    accountingCompanyId: $accountingCompanyId
                                }
                            ) {
                                bankAccounts
                                error
                            }
                        }
                    `,
                    variables: {
                        fileName: self.fileName,
                        stream: self.stream,
                        accountingCompanyId: self.company.id,
                    },
                });

                if (mutationResult.data && mutationResult.data.analyseEBICS) {
                    if (mutationResult.data.analyseEBICS.error) {
                        self.error = mutationResult.data.analyseEBICS.error;
                    } else if (mutationResult.data.analyseEBICS.bankAccounts) {
                        self.bankAccounts = mutationResult.data.analyseEBICS.bankAccounts.map(
                            (x) => ({ ...x, isActive: true }),
                        );
                        self.windowStep = 1;
                    }
                }
            };
            reader.readAsText(e.file);
        }
    }

    async valid() {
        this.loading = true;
        if (this.selectedAccountingItemImport) {
            this.reloadImport(this.selectedAccountingItemImport);
            this.closeEbicsDialog();
        } else {
            await this.$apollo.mutate({
                mutation: gql`
                    mutation ImportEBICS(
                        $fileName: String!
                        $stream: String!
                        $accountingCompanyId: ID!
                    ) {
                        importEBICS(
                            data: {
                                fileName: $fileName
                                stream: $stream
                                accountingCompanyId: $accountingCompanyId
                            }
                        ) {
                            status
                        }
                    }
                `,
                variables: {
                    fileName: this.fileName,
                    stream: this.stream,
                    accountingCompanyId: this.company.id,
                },
            });
            this.windowStep = 2;
        }
        this.loading = false;
    }

    async reloadImport(id) {
        await this.$apollo.mutate({
            mutation: UPDATE_EBICS,
            variables: {
                accountingItemImportIds: [id],
                forceImport: true,
            },
        });
    }

    async displayBankTransactions(item) {
        if (!item || !item.id) {
            debugger; // git-ignore
            return;
        }
        this.windowStep = 1;
        this.ebicsDialog = true;
        this.bankAccounts = [];
        this.selectedAccountingItemImport = item.id;
        const mutationResult = await this.$apollo.mutate({
            mutation: gql`
                mutation AnalyseEBICS($accountingItemId: ID, $forceImport: Boolean) {
                    analyseEBICS(
                        data: { accountingItemId: $accountingItemId, forceImport: $forceImport }
                    ) {
                        bankAccounts
                        error
                        totalBankTransactionCount
                    }
                }
            `,
            variables: {
                accountingItemId: this.selectedAccountingItemImport,
                forceImport: true,
            },
        });
        if (mutationResult.data && mutationResult.data.analyseEBICS) {
            if (mutationResult.data.analyseEBICS.error) {
                this.error = mutationResult.data.analyseEBICS.error;
            } else if (mutationResult.data.analyseEBICS.bankAccounts) {
                let bankAccounts = JSON.parse(
                    JSON.stringify(
                        mutationResult.data.analyseEBICS.bankAccounts.map((x) => ({
                            ...x,
                            isActive: true,
                        })),
                    ),
                );
                this.bankAccounts.length = 0;
                this.bankAccounts = bankAccounts;
                this.totalBankTransactionImported =
                    mutationResult.data.analyseEBICS.totalBankTransactionCount;
                this.windowStep = 1;
            }
        }
    }

    async updateBankTransactionAPIs() {
        if (!this.company.profile.id) {
            return;
        }
        this.loadingUpdateAPI = true;
        const today = moment().startOf("day");
        const daysDifference = moment.duration(moment(today).diff(this.dateStart, "days")).asDays();
        this.$apollo.mutate({
            mutation: UPDATE_BANK_TRANSACTIONS_APIS,
            variables: {
                profileId: this.company.profile.id,
                daysDifference: daysDifference,
            },
        });
        this.snackbar = true;
        setTimeout(() => {
            this.snackbar = false;
        }, 50000);
    }

    async updateSobankAPIs() {
        if (!this.company.profile.id) {
            return;
        }
        this.loadingUpdateAPI = true;
        let today = moment().startOf("day");
        let daysDifference = moment.duration(moment(today).diff(this.dateStart)).asDays();
        this.$apollo.mutate({
            mutation: UPDATE_SOBANK_APIS,
            variables: {
                profileId: this.company.profile.id,
                daysDifference: daysDifference,
            },
        });
        debugger;
        this.snackbar = true;
        setTimeout(() => {
            this.snackbar = false;
        }, 50000);
    }

    deleteAccountingItemImportLoading: boolean = false;

    async rejectAccountingItemImport() {
        if (this.toDeleteAccountingItemImportId) {
            this.deleteAccountingItemImportLoading = true;
            await this.$apollo
                .mutate({
                    mutation: DELETE_EDIT_ACCOUNTING_ITEM_IMPORT,
                    variables: {
                        id: this.toDeleteAccountingItemImportId,
                        delete: false,
                        status: "REJECTED",
                    },
                })
                .catch((err) => {});
            this.refresh();
            this.toDeleteAccountingItemImportId = "";
            this.deleteAccountingItemImportLoading = false;
            this.rejectAccountingItemImportDialog = false;
        }
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    statusColor(status) {
        switch (status) {
            case "EDITION":
                return "green";
            case "RUNNING_IMPORT":
                return "green";
            case "IMPORTED":
                return "green";
            case "IMPORTED_WITH_ERRORS":
                return "red";
            case "RUNNING_DELETE":
                return "red";
            case "REJECTED":
                return "orange";
        }
        debugger; // git-ignore
        return "red";
    }
}

export default toNative(ImportEBICS);
</script>

<style scoped>
.v-virtual-scroll__item:nth-child(2n) {
    background-color: #fff;
    border: none;
}

.v-virtual-scroll__item:nth-child(2n + 1) {
    background-color: #fef8ee;
    border: none;
}
</style>
